import { memo } from 'react';
import styled from 'styled-components';

const UserTag = memo(styled.div`
  font-family: Lato, sans-serif;
  border-radius: 2px;
  background-color: #FFB7B5;
  color: #FFF;
  font-size: 12px;
  padding: 0 4px;
  margin: 0 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 18px;
  height: 18px;
`);

export default UserTag;
